// Returns an object with the config variables that are defined in .env files
// Environment variables must also be whitelisted in /next.config.js
export const getPublicConfigVars = (): NodeJS.ProcessEnv => process.env;
export const getServerConfigVars = (): NodeJS.ProcessEnv => process.env;

export const IS_PROD = process.env.BUILD_ENV === 'production';
